import type { ReactNode } from 'react';

import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import styles from './FieldHelp.module.css';

export interface FieldHelpProps {
  className?: string;
  /** 悬停时展示的说明文案。 */
  content: ReactNode;
  /**
   * 问号按钮的可访问名称，取完整名称（如「有效期说明」），
   * 由调用方给全，避免各处自己拼「XX说明」拼出不同写法。
   */
  label: string;
}

/**
 * 字段说明问号：表头与表单标签共用的 16px 线条问号 + 悬停提示。
 * 原先 `Table.module.css` 与创建电子推荐卡的页面 CSS 各手写一份，形态已经开始漂移。
 */
export function FieldHelp({ className, content, label }: FieldHelpProps) {
  return <Tooltip content={content}>
    <button aria-label={label} className={[styles.root, className].filter(Boolean).join(' ')} data-icon="bangzhuzhongxin" type="button">
      <Icon name="bangzhuzhongxin" size="base" />
    </button>
  </Tooltip>;
}
